import { normalize, schema } from 'normalizr'

import { getIdsFromArray } from '@/utils/utils'
import { adaptTaxonomySkillsToStore } from '@/utils/skills'
import isNil from 'lodash.isnil'
import omitBy from 'lodash.omitby'

const labsSchema = new schema.Entity('labs')
const labsListSchema = [labsSchema]

const categorySchema = new schema.Entity('categories')
const categoryListSchema = [categorySchema]

export function adaptLabsToStore({ data }) {
  const entries = normalize(data.results, labsListSchema)
  return {
    entries: entries.entities.labs,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results,
  }
}

export function adaptLabsCategoriesToStore({ data }) {
  const entries = normalize(data.results, categoryListSchema)

  return {
    entries: entries.entities.categories,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results,
  }
}

export function adaptLabToApi(lab = {}) {
  let payload = {
    ...lab,
  }
  delete payload.description_html
  delete payload.duration_in_seconds
  delete payload.taxonomy_skills
  if (
    !payload.metadata.els_lab_id &&
    payload.metadata.hasOwnProperty('els_lab_id')
  )
    delete payload.metadata.els_lab_id
  payload = omitBy(payload, isNil)

  payload.explanation_video = lab.explanation_video || null
  payload.solution_video = lab.solution_video || null
  payload.severity = lab.severity || null
  payload.cve = lab.cve || null
  payload.year = lab.year || null
  payload.classification = lab.classification || null

  return payload
}

export function adaptLabToStore({ data }) {
  const lab = {
    ...data,
    learning_areas: getIdsFromArray(data.learning_areas),
    categories: getIdsFromArray(data.categories),
  }

  if (Array.isArray(data.taxonomy_skills)) {
    lab.taxonomy_skills = adaptTaxonomySkillsToStore(data.taxonomy_skills)
  }

  return lab
}

export function adaptObjectivesToStore({ data }) {
  return {
    ...data,
  }
}

export function adaptObjectiveToStore({ data }) {
  return {
    ...data,
  }
}

export function adaptObjectiveToApi(data) {
  return {
    ...data,
  }
}
